module.exports = __webpack_public_path__ + "img/31-ABITO-BRENDA-U-COLORI-GARZA-COLORI-RETE12.71a41bbf.jpg";